import CryptoManager from './cryptoManager';

const cryptoManager = new CryptoManager();

export default cryptoManager;
